export default __webpack_public_path__ + "static/media/img-stacking-nft.741a9dd6.png";